<template>
  <q-page padding>
    <PageHeader
      title="Agendamento de Comando"
      :backRoute="{ name: 'home' }"
      backBehavior="route"
    />
    <div class="row col-12 q-mt-lg">
      <div class="col-2 text-brand-5 text-weight-bold">
        Cliente
        <q-select
          v-model="filtros.cliente"
          option-label="clienteId"
          :options="listaClientesFiltros"
          dense
          outlined
        />
      </div>
    </div>
    <div class="row col-12 q-mt-lg">
      <q-btn
        label="Criar Novo"
        no-caps
        icon="add"
        color="positive"
        @click="rightDrawerOpen = true"
      />
      <q-btn
        label="Enviar Comando"
        class="q-ml-sm"
        no-caps
        icon="add"
        color="positive"
        @click="(rightDrawerOpen2 = true), (rightDrawerOpen = true)"
      />
    </div>
    <q-tabs
      v-model="tab"
      dense
      class="text-grey bg-grey-3 q-mt-xl"
      active-color="primary"
      indicator-color="primary"
      align="justify"
      narrow-indicator
    >
      <q-tab name="agendados" label="Agendamentos" />
      <q-tab name="enviados" label="Enviados" />
    </q-tabs>
    <q-tab-panels v-model="tab" animated>
      <q-tab-panel name="agendados">
        <div v-if="filtros.cliente != ''" class="text-brand-5 text-weight-bold">
          <div class="q-my-lg" style="font-size: 18px">
            Lista de Agendamentos Criados
          </div>
          <q-table
            table-header-class="bg-accent text-width-bold"
            flat
            dense
            :columns="columns"
            :rows="listaAgendamentosCriados"
            hide-bottom
            :rows-per-page-options="[0]"
            class="my-sticky-dynamic"
            :loading="loading"
            color="primary"
          >
            <template v-slot:header="props">
              <q-tr :props="props">
                <q-th v-for="col in props.cols" :key="col.name" :props="props">
                  {{ col.label }}
                </q-th>
              </q-tr>
            </template>
            <template v-slot:body="props">
              <q-tr class="text-brand-5 text-weight-bold">
                <q-td>{{ props.row.clienteId }}</q-td>
                <q-td>{{ props.row.cronExpression }}</q-td>
                <q-td>{{ props.row.modeloId }}</q-td>
                <q-td>{{ props.row.parametros }}</q-td>
                <q-td>
                  <q-btn
                    class="q-mr-md"
                    icon="delete"
                    round
                    color="red"
                    flat
                    @click="
                      excluirAngedamentoCriado(
                        props.row.clienteId,
                        props.row.modeloId
                      )
                    "
                  />
                </q-td>
              </q-tr>
            </template>
          </q-table>
        </div>

        <span
          v-else
          class="row q-pa-md text-bold text-black texto-alerta bg-positive"
          >Selecione um cliente</span
        >
      </q-tab-panel>
      <q-tab-panel name="enviados">
        <div v-if="filtros.cliente != ''" class="text-brand-5 text-weight-bold">
          <div class="q-my-lg" style="font-size: 18px">
            Lista de Agendamentos Enviados
          </div>
          <q-table
            table-header-class="bg-accent text-width-bold"
            flat
            dense
            :columns="columns"
            :rows="listaAgendamentosCriados"
            hide-bottom
            :rows-per-page-options="[0]"
            class="my-sticky-dynamic"
            :loading="loading"
            color="primary"
          >
            <template v-slot:header="props">
              <q-tr :props="props">
                <q-th v-for="col in props.cols" :key="col.name" :props="props">
                  {{ col.label }}
                </q-th>
              </q-tr>
            </template>
            <template v-slot:body="props">
              <q-tr class="text-brand-5 text-weight-bold">
                <q-td>{{ props.row.clienteId }}</q-td>
                <q-td>{{ props.row.cronExpression }}</q-td>
                <q-td>{{ props.row.modeloId }}</q-td>
                <q-td>{{ props.row.parametros }}</q-td>
                <q-td>
                  <q-btn
                    class="q-mr-md"
                    icon="delete"
                    round
                    color="red"
                    flat
                    @click="
                      excluirAngedamentoCriado(
                        props.row.clienteId,
                        props.row.modeloId
                      )
                    "
                  />
                </q-td>
              </q-tr>
            </template>
          </q-table>
        </div>
        <span
          v-else
          class="row q-pa-md text-bold text-black texto-alerta bg-positive"
          >Selecione um cliente</span
        >
      </q-tab-panel>
    </q-tab-panels>

    <Transition name="slide-fade">
      <q-card v-if="rightDrawerOpen" class="drawer-modal">
        <div class="row q-pa-md text-weight-bold">
          <div class="row col-12 items-center">
            <q-icon
              style="cursor: pointer"
              name="close"
              class="q-mr-md"
              size="22px"
              @click="(rightDrawerOpen = false), (rightDrawerOpen2 = false)"
            />
            <span style="font-size: 16px">
              <span>
                <span> Criar Agendamento </span>
              </span>
            </span>
          </div>
        </div>
        <div
          class="column col-12 justify-between no-wrap"
          style="width: 100%; height: 90%"
        >
          <div class="q-px-md text-weight-bold">
            <div class="col-md-12 q-mt-xs">
              <div class="q-mb-xs">Comandos</div>
              <q-select
                option-label="descricao"
                :options="listaComandos"
                v-model="dados.modeloEventos"
                dense
                outlined
              />
              <div
                v-if="dados.modeloEventos"
                class="container-dados-evento q-mt-md row items-center q-pa-sm"
              >
                <div
                  class="row col-12 justify-between text-dados q-mb-sm"
                ></div>
                <div>
                  <span>Parametros: {{ dados?.modeloEventos?.schema }}</span>
                </div>
              </div>
            </div>
            <div class="q-mt-xs">
              <div class="q-mb-xs">Cliente</div>
              <q-select
                v-model="dados.cliente"
                option-label="clienteId"
                :options="listaClientes"
                dense
                outlined
              />
            </div>
            <div v-if="rightDrawerOpen2 != true" class="q-mt-xs">
              <div class="q-mb-xs">
                <span>Cron Expression</span>
                <a href="https://crontab.guru/#0_4_8-14_*_*" target="_blank">
                  <q-icon
                    color="brand-5"
                    class="q-ml-xs"
                    name="info"
                    size="20px"
                  />
                </a>
              </div>
              <q-input v-model="dados.cronExpression" dense outlined />
            </div>
            <div class="q-mt-xs">
              <div class="q-mb-xs">Parâmetros</div>

              <q-input
                v-model="dados.parametros"
                :disable="dados.modeloEventos?.modeloId == undefined"
                type="textarea"
                @change="jsonValidatorParametros"
                dense
                outlined
                :input-style="{ maxHeight: '100px' }"
              />
            </div>
          </div>
          <div class="q-ml-md q-mt-md q-mb-sm">
            <q-btn
              v-if="rightDrawerOpen2 != true"
              label="Criar"
              icon="check_circle_outline"
              no-caps
              :disable="desabilitarCriacaoAgendamento"
              color="positive"
              @click="agendarComando()"
            />
            <q-btn
              v-if="rightDrawerOpen2 == true"
              label="Enviar"
              icon="check_circle_outline"
              no-caps
              :disable="desabilitarCriacaoAgendamento"
              color="positive"
              @click="enviarComando()"
            />
          </div>
        </div>
      </q-card>
    </Transition>
    <div
      v-if="rightDrawerOpen"
      @click="(rightDrawerOpen = false), (rightDrawerOpen2 = false)"
      class="mascara"
    ></div>
  </q-page>
</template>

<script>
import { useQuasar } from "quasar";
import { ref, onMounted, watch } from "vue";
import { useStore } from "vuex";
import PageHeader from "../../../components/PageHeader.vue";

const columns = [
  {
    name: "clienteId",
    label: "Cliente Id",
    align: "left",
  },
  {
    name: "cronExpression",
    label: "Cron Expression",
    align: "left",
  },
  {
    name: "modeloId",
    label: "Comando",
    align: "left",
  },
  {
    name: "parametros",
    label: "Parâmetros",
    align: "left",
  },
  {
    name: "excluir",
    label: "Excluir",
    align: "left",
  },
];
export default {
  components: { PageHeader },
  setup() {
    const store = useStore();
    const quasar = useQuasar();
    const Validator = require("jsonschema").Validator;
    const jsonValidator = new Validator();
    const listaClientesFiltros = ref([]);
    const schema = ref(null);
    const tab = ref("agendados");
    const listaComandos = ref([]);
    const dados = ref({
      modeloEventos: "",
      cliente: "",
      cronExpression: "",
      parametros: "",
    });
    const operadorValidator = ref([]);
    const listaClientes = ref([]);
    let rightDrawerOpen = ref(false);
    let rightDrawerOpen2 = ref(false);
    const listaAgendamentosCriados = ref([]);
    const filtros = ref({ cliente: "" });
    const desabilitarCriacaoAgendamento = ref(true);
    let loading = ref(false);

    const listarComandos = async () => {
      try {
        const response = await store.dispatch("office/listarComandos");
        listaComandos.value = response.data.resultado.dados;
      } catch (error) {
        console.log(error);
      }
    };

    const listarClientes = async () => {
      try {
        const response = await store.dispatch("office/listarCliente");
        response.listaClientes.forEach((e) => {
          listaClientesFiltros.value.push(e);
        });

        listaClientes.value = response.listaClientes;
      } catch (error) {
        console.log(error);
      }
    };

    const listarAgendamentosCriados = async () => {
      loading.value = true;
      try {
        const response = await store.dispatch(
          "office/listarAgendamentosCriados",
          {
            clienteId:
              filtros.value.cliente.clienteId != "Todos"
                ? filtros.value.cliente.clienteId
                : undefined,
            tipo: tab.value == "agendados" ? undefined : "comando",
          }
        );

        listaAgendamentosCriados.value = response.data.resultado.dados;
        loading.value = false;
      } catch (error) {
        console.log(error);
      }
    };

    const agendarComando = async () => {
      try {
        await store.dispatch("office/agendarComando", {
          modeloId: dados.value.modeloEventos?.modeloId,
          clienteId: dados.value.cliente?.clienteId,
          cronExpression: dados.value.cronExpression,
          parametros: dados.value.parametros,
        });
        listarAgendamentosCriados();
        resetVariaveis();
        rightDrawerOpen.value = false;
        quasar.notify({
          message: "Comando agendado com sucesso.",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      } catch (error) {
        quasar.notify({
          message:
            "Erro a o agendar comando, verifique os campos ou se ja existe um agendado nesse cliente",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    const enviarComando = async () => {
      try {
        await store.dispatch("office/enviarComando", {
          clienteId: dados.value.cliente?.clienteId,
          modeloNome: dados.value.modeloEventos?.nome,
          corpo: dados.value.parametros,
        });
        listarAgendamentosCriados();
        resetVariaveis();
        rightDrawerOpen.value = false;
        quasar.notify({
          message: "Comando enviado com sucesso.",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      } catch (error) {
        quasar.notify({
          message: "Erro a o enviar comando",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    const resetVariaveis = () => {
      dados.value = {
        modeloEventos: "",
        cliente: "",
        cronExpression: "",
        parametros: "",
      };
    };
    watch(
      () => dados.value.modeloEventos,
      () => {
        if (dados.value.modeloEventos == "") {
          return;
        }
        schema.value = JSON.parse(dados.value.modeloEventos.schema);
      }
    );

    const jsonValidatorParametros = async () => {
      desabilitarCriacaoAgendamento.value = true;
      try {
        if (dados.value.parametros == "") {
          return;
        }
        const parametrosJson = JSON.parse(dados.value.parametros);
        if (jsonValidator.validate(parametrosJson, schema.value).valid) {
          desabilitarCriacaoAgendamento.value = false;
        }
      } catch (error) {
        quasar.notify({
          message: `Não e um JSON valido: ${dados.value.parametros}`,
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    const excluirAngedamentoCriado = async (clienteId, modeloId) => {
      try {
        await store.dispatch("office/excluirCriado", {
          clienteId: clienteId,
          modeloId: modeloId,
        });

        quasar.notify({
          message: "Agendamento excluido com sucesso",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        listarAgendamentosCriados();
      } catch (error) {
        quasar.notify({
          message: "Erro a o excluir agendamento",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    watch(
      () => filtros.value.cliente,
      () => {
        listarAgendamentosCriados();
      }
    );

    watch(
      () => tab.value,
      () => {
        listarAgendamentosCriados();
      }
    );

    onMounted(() => {
      listarComandos();
      listarClientes();
      listarAgendamentosCriados();
    });

    return {
      columns,
      listarComandos,
      listaComandos,
      dados,
      listarClientes,
      listaClientes,
      rightDrawerOpen,
      rightDrawerOpen2,
      agendarComando,
      listaAgendamentosCriados,
      loading,
      filtros,
      operadorValidator,
      desabilitarCriacaoAgendamento,
      jsonValidatorParametros,
      jsonValidator,
      schema,
      listarAgendamentosCriados,
      enviarComando,
      listaClientesFiltros,
      tab,
      excluirAngedamentoCriado,
    };
  },
};
</script>

<style scoped>
q-table__top,
thead tr:first-child th {
  background-color: #eef3fe;
}

thead tr th {
  position: sticky;
  z-index: 1;
}
thead tr:first-child th {
  top: 0;
}

.q-table--loading thead tr:last-child th {
  top: 48px;
}
.my-sticky-dynamic {
  max-height: 400px;
}
thead tr th {
  position: sticky;
  z-index: 1;
}
thead tr:last-child th {
  top: 48px;
}
thead tr:first-child th {
  top: 0;
}
.container-dados-evento {
  background: #b3e5be;
  border-radius: 4px;
  color: black;
}
.text-dados {
  word-wrap: break-word;
}
a {
  text-decoration: none;
}

.texto-alerta {
  border-radius: 6px;
}
.container {
  height: 100%;
}
.animacao {
  transition: all 0.5s;
  cursor: pointer;
}
.animacao:hover {
  -webkit-transform: scale(1.1);
  -ms-transform: scale(1.1);
  transform: scale(1.1);
}
.drawer-modal {
  border: 2px solid black;
  position: absolute;
  right: 0;
  width: 450px;
  position: fixed;
  top: 106px;
  height: 80%;
  max-height: 650px;
  border-radius: 10px 1px 1px 10px;
  margin: 2px;
  z-index: 3;
  overflow: hidden;
}
.slide-fade-enter-active {
  transition: all 0.5s ease-out;
}
.slide-fade-leave-active {
  transition: all 0.5s cubic-bezier(1, 0.5, 0.8, 1);
}

.slide-fade-enter-from,
.slide-fade-leave-to {
  transform: translateX(400px);
}
.mascara {
  background-color: black;
  height: 100%;
  width: 100%;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 2;
  opacity: 0.4;
}
@media (max-width: 1200px) {
  .drawer-modal {
    max-height: 85%;
  }
}
@media (max-width: 900px) {
  .drawer-modal {
    max-height: 80%;
    top: 118px;
  }
}
@media (max-width: 600px) {
  .drawer-modal {
    max-height: 80%;
    top: 107px;
  }
}
</style>
